import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import UploadPruchaseOrderForm from "@/v2/components/pages/purchase-order/UploadForm";
import { EditIcon } from "lucide-react";

export default function EditUploadPurchaseOrder({
    id,
    isInside,
    type,
    status,
}: {
    id: string;
    isInside?: boolean;
    type:
        | "MANPOWER_PURCHASE_ORDER"
        | "PROJECT_PURCHASE_ORDER"
        | "EQUIPMENT_RENTAL_PURCHASE_ORDER"
        | "RECEIVED_PURCHASE_ORDER";
    status: "ISSUED" | "RECEIVED" | "DRAFT";
}) {
    const [open, setOpen] = useState(false);
    return (
        <Dialog open={open} onOpenChange={(value) => setOpen(value)}>
            <DialogTrigger asChild>
                <Button
                    size={"sm"}
                    variant={"outline"}
                    className="flex items-center gap-2"
                >
                    <EditIcon className="h-4 w-4" />
                    {isInside && "Edit"}
                </Button>
            </DialogTrigger>
            <DialogContent className="">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-semibold tracking-tight">
                        Edit Uploaded Purchase Order
                    </DialogTitle>
                    <DialogDescription className="text-sm text-muted-foreground">
                        Fill in the details to edit the uploaded purchase order
                    </DialogDescription>
                </DialogHeader>
                <UploadPruchaseOrderForm
                    id={id}
                    type={type}
                    status={status}
                    closeOnSave={() => setOpen(false)}
                />
            </DialogContent>
        </Dialog>
    );
}
